import restUtils from "core/utils/rest";
import {
  PaginatedPermissionRequest,
  PaginatedPermissions,
  Permissions,
} from "../model";

const UMAPI = "UserManagementApi";
const PERMISSION_API = "user-roles/roles/permissions";

class PermissionStore {
  getPermissions = async (payload: PaginatedPermissionRequest) => {
    return await restUtils.call<PaginatedPermissions>(
      UMAPI,
      PERMISSION_API,
      "GET",
      payload
    );
  };

  getPermissionById = async (id: any) => {
    return await restUtils.call<Permissions>(
      UMAPI,
      `${PERMISSION_API}/${id}`,
      "GET"
    );
  };

  createPermission = async (payload: Permissions) => {
    return await restUtils.call(UMAPI, PERMISSION_API, "POST", payload);
  };

  updatePermission = async (id: any, payload: Permissions) => {
    return await restUtils.call(
      UMAPI,
      `${PERMISSION_API}/${id}`,
      "PUT",
      payload
    );
  };
}

const permissionStore = new PermissionStore();
export default permissionStore;
